import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Hero } from '../components/home/Hero';
import { Principles } from '../components/home/Principles';
import { Steps } from '../components/home/Steps';
import { Transparency } from '../components/home/Transparency';
import { LabsPreview } from '../components/home/LabsPreview';
import { PharmacyPreview } from '../components/home/PharmacyPreview';
import { Testimonial } from '../components/home/Testimonial';
import { ProgramTable } from '../components/programs/ProgramTable';
import { SectionHeading } from '../components/ui/SectionHeading';
import { FaqList } from '../components/ui/FaqList';
import { CtaBand } from '../components/ui/CtaBand';
import { programs } from '../data/programs';
import { faqs } from '../data/site';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
export function Home() {
  useDocumentMeta({
    title: 'Republic — Healthcare belongs to everyone.',
    description: 'Clinically directed care and medications delivered with exceptional quality, convenience, transparency and pricing.'
  });
  return <main data-id="element-350" data-mp="2vy82edtt8hm4">
      <Hero data-id="element-351" data-mp="2vyhss2iroqsc" />

      <section className="bg-cream-light" data-id="element-352" data-mp="2vvlz4qdyco9p">
        <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-353" data-mp="2qxu3bla6si08">
          <div className="flex flex-wrap items-end justify-between gap-8" data-id="element-354" data-mp="2mxa8iod35qh9">
            <SectionHeading eyebrow="Programs" title="Six programs. One clinical standard." intro="Each program is a written protocol, a named pharmacy and a published price — not a catalogue of products." data-id="element-355" data-mp="2mz3498m5uqah" />
            <Link to="/programs" className="group inline-flex items-center gap-2 pb-2 text-sm text-ink transition-colors duration-150 ease-republic hover:text-brick" data-id="element-356" data-mp="288vvxlpvanni">
              All programs
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-republic group-hover:translate-x-1" data-id="element-357" data-mp="1z9ihsfqstawg" />
            </Link>
          </div>
          <ProgramTable items={programs} data-id="element-358" data-mp="1kjnv547ha5wz" />
        </div>
      </section>

      <Principles data-id="element-359" data-mp="1omu088iutr1v" />
      <Steps data-id="element-360" data-mp="1ondixrgbwjgy" />
      <Transparency data-id="element-361" data-mp="1on3rdzfmy495" />
      <PharmacyPreview data-id="element-362" data-mp="1ok7tgb3sffkp" />
      <LabsPreview data-id="element-363" data-mp="1amjaj8ta6iia" />
      <Testimonial data-id="element-364" data-mp="1an2uev2hrgyy" />

      <section className="bg-cream" data-id="element-365" data-mp="1anunnz8m92m2">
        <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-366" data-mp="1aovzw71dbv5d">
          <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20" data-id="element-367" data-mp="1fm5vk4fcp31n">
            <SectionHeading eyebrow="Questions" title="Answered plainly." data-id="element-368" data-mp="23c9qlneh3uh1" />
            <FaqList items={faqs} data-id="element-369" data-mp="28atcxowzb89x" />
          </div>
        </div>
      </section>

      <CtaBand data-id="element-370" data-mp="1tlf2selkwmth" />
    </main>;
}